import React from 'react';
import logo from './logo.svg';
import './App.css';

import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { isTemplateExpression } from 'typescript';

function getTableData() {

    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open( "GET", "https://temptable-ugdebiz6jq-uc.a.run.app", false ); // false for synchronous request
    xmlHttp.send( null );
    return xmlHttp.responseText;
}

type DateTimeTemp = {
  datetime: string;
  temp: number;
  pres: number;
  humi: number;
}

const retData = getTableData();
const data = JSON.parse(retData).table as DateTimeTemp[];
const dateTrimed = data.map( x => {
  const container = {} as DateTimeTemp ;
  container.datetime = x.datetime.slice(11,16);
  container.temp = x.temp;
  container.pres = x.pres;
  container.humi = x.humi;
  return container;
});


const data2 = JSON.parse(retData).table.pop();
const lastDateTime = data2.datetime;
const lastTemp = data2.temp;
const lastPressure = data2.pres;
const lastHumidity =data2.humi;

function App() {
  return (
    <div className="App">
      <header className="App-header">

    <h2>Temperaturen i stugan: {lastTemp} Celsius</h2>
    <h2>(tidpunkt: {lastDateTime})</h2>
    <ResponsiveContainer width="95%" height={400}>
    <LineChart width={600} height={600} data={dateTrimed} margin={{ top: 5, right: 20, bottom: 5, left: 30 }}>
      <Line type="monotone" dataKey="temp" stroke="#8884d8" />
      <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
      <XAxis dataKey="datetime" tick={{fontSize: 10, fill:'white'}}/>
      <YAxis />
      <Tooltip />
    </LineChart>
    </ResponsiveContainer>
    <h2>Lufttryck i stugan: {lastPressure} hPa</h2>
    <ResponsiveContainer width="95%" height={400}>
    <LineChart width={600} height={600} data={dateTrimed} margin={{ top: 5, right: 20, bottom: 5, left: 30 }}>
      <Line type="monotone" dataKey="pres" stroke="#8884d8" />
      <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
      <XAxis dataKey="datetime" tick={{fontSize: 10, fill:'white'}}/>
      <YAxis />
      <Tooltip />
    </LineChart>
    </ResponsiveContainer>
    <h2>Luftfuktighet i stugan: {lastHumidity} %</h2>
    <ResponsiveContainer width="95%" height={400}>
    <LineChart width={600} height={600} data={dateTrimed} margin={{ top: 5, right: 20, bottom: 5, left: 30 }}>
      <Line type="monotone" dataKey="humi" stroke="#8884d8" />
      <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
      <XAxis dataKey="datetime" tick={{fontSize: 10, fill:'white'}}/>
      <YAxis />
      <Tooltip />
    </LineChart>
    </ResponsiveContainer>
      </header>
    </div>
  );
}

export default App;
